export default "__VITE_ASSET__N4ZmiaJh__"